/* jshint esversion: 6 */

/**
 * @module
 * the app is responsible for global events and
 * responsibilities.
 */

const selector = '.Ge-Messages-EditGlobalMessage';
const messagesEditGlobalMessage = function (el, app) {

    const $elt = $(el);
    const $form = $elt.find("form");
    const $saveButton = $(selector + "-SaveButton");
    const $logoutButton = $(selector + "-LogoutButton");
    const $message = $(selector + "-Message input");
    const $active = $(selector + "-IsActive input");
    const $onStartPageOnly = $(selector + "-OnStartPageOnly input");
    const $saving = $(selector + "-Saving");
    const $complete = $(selector + "-Msg-Complete");
    const $loggedOut = $(selector + "-LoggedOut");

    const init = function () {

        $(function () {
            $logoutButton.click(ev => {
                ev.stopPropagation();
                ev.preventDefault();
                logout();
            });
            $saveButton.click(ev => {
                ev.stopPropagation();
                ev.preventDefault();
                $form.trigger('formValidate', { submit: save })
            });
        });
    };

    const logout = function () {
        Ge.Web20.Util.callApi("/GeneralApi", {
            command: "Logout"
        }).then(function () {
            $loggedOut.removeClass("Ge-Hidden");
            $elt.remove();
        });

    };

    const save = function () {
        $saving.removeClass("Ge-Hidden");

        Ge.Web20.Util.callApi("/GeneralApi", {
            command: "SetGlobalMessage",
            message: $message.val(),
            isActive: $active.is(":checked") ? "1" : "0",
            onStartPageOnly: $onStartPageOnly.is(":checked") ? "1" : "0"
        }).then(function () {
            $saving.addClass("Ge-Hidden");
            $complete.removeClass("Ge-Hidden");
        });
    };

    return {
        init: init()
    };
};

messagesEditGlobalMessage.selector = selector;

export default messagesEditGlobalMessage;
